import styleInject from '../../util/injectCss.js';

var css_248z = "#story--misc-components-selection-selectionmenu--selection-menu-example-with-position {\n  min-height: 280px; }\n\n#story--misc-components-selection-selectionmenu--selection-menu-example {\n  min-height: 280px; }\n\n#story--misc-components-selection-selectionmenu--main-story {\n  display: flex;\n  justify-content: center; }\n";
styleInject(css_248z);

export { css_248z as default };
